export const getQueryParam = name => {
  return new URLSearchParams(window.location.search).get(name);
};

export const addQueryParam = (name, val) => {
  const newUrl = new URL(window.location.href);
  newUrl.searchParams.append(name, val);
  return `${window.location.pathname}${newUrl.search}`;
};

export const removeQueryParam = name => {
  const newUrl = new URL(window.location.href);
  newUrl.searchParams.delete(name);
  return `${window.location.pathname}${newUrl.search}`;
};
